import React from 'react';
import styled from 'styled-components';
import appConfig from '../../../../app-config';
import moment from 'moment';
import { AsYouType } from 'libphonenumber-js';
import { Headline } from '../../../components/Typography';
import {
  ORDER_SUBMITTED,
  ORDER_ACCEPTED,
  ORDER_COMPLETE,
  ORDER_ON_DELIVERY,
  ORDER_READY_TO_PICKUP,
} from '../orderStatusTypes';
import Icon from './Icon';
import { useMemo } from 'react';
import Feedback from './Feedback';
import { isGuestOrderInfoClient } from '../../../clientCustomizations';
const Wrapper = styled.div``;
const SummaryWrapper = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr 120px;
  grid-template-rows: 40px 75px 40px 75px 40px 50px;
  width: 100%;
`;
const Step1Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1;
  grid-row: 1;
`;
const Step2Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1;
  grid-row: 3;
`;
const Step3Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1;
  grid-row: 5;
`;
const Divider1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1;
  grid-row: 2;
`;
const Divider2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1;
  grid-row: 4;
`;
const Title1 = styled.div`
  display: flex;
  align-items: center;
  grid-column: 2;
  grid-row: 1;
  padding-left: 10px;
`;
const Title2 = styled.div`
  display: flex;
  align-items: center;
  grid-column: 2;
  grid-row: 3;
  padding-left: 10px;
`;
const Title3 = styled.div`
  display: flex;
  align-items: center;
  grid-column: 2;
  grid-row: 5;
  padding-left: 10px;
`;
const SubTitle1 = styled.div`
  grid-column: 2;
  grid-row: 2;
  padding-left: 10px;
`;
const SubTitle2 = styled.div`
  grid-column: 2;
  grid-row: 4;
`;
const SubTitle3 = styled.div`
  grid-column: 2;
  grid-row: 6;
  padding-left: 10px;
`;
const Time1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-column: 3;
  grid-row: 1;
`;
const Time2 = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-column: 3;
  grid-row: 3;
`;
const Time3 = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-column: 3;
  grid-row: 5;
`;
const Date1 = styled.div`
  grid-column: 3;
  grid-row: 2;
  text-align: right;
`;
const Date2 = styled.div`
  grid-column: 3;
  grid-row: 4;
  text-align: right;
`;
const Date3 = styled.div`
  grid-column: 3;
  grid-row: 6;
  text-align: right;
`;
const OrderNumber = styled.div`
  height: 17px;
  font-size: 14px;
  font-weight: 600;
  color: black;
  margin: 0 0 10px 0;
`;
const AddressWrapper = styled.div`
  font-size: 14px;
`;
const DetailsWrapper = styled.div`
  font-size: 14px;
  color: black;
  display: ${(props) => props?.display || 'flex'};
  align-items: center;
  gap: 5px;
  margin: ${(props) => props.margin || 0};
`;
const Subtitle = styled.div`
  height: 17px;
  font-size: 14px;
  font-weight: 600;
  color: black;
  margin: 15px 0 10px 0;
`;
const Text = styled.span`
  height: 17px;
  font-size: 14px;
  color: black;
  margin-right: ${(props) => props.marginRight || 0};
`;
const DetailTitle = styled(Headline)`
  font-weight: 600;
  width: max-content;

  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    border-bottom: ${(props) => props.categoriesBarSelectedBorderColorWidth}
      solid ${(props) => props.theme.orderStatusTitleBarBorderColor};
  }
`;
const OrderDetailDescription = styled.div`
  font-size: 12px;
  color: #737a87;
`;
const UberDetail = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: black;

  a {
    color: #e46518;
    text-decoration: none;
  }
`;
const OrderDetailTitle = styled.div`
  font-family: Inter, sans-serif;
  font-size: 12px;
`;
const VerticalRect = styled.div`
  width: 2px;
  height: 50px;
  border-radius: 1px;
  background-color: ${(props) => props.customColor || '#e0e0e0'};
  margin-top: 5px;
  margin-bottom: 5px;
`;
const FontAwesomeIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.orderStatusDisabledIconColor || '#dbd9d9'
      : props.theme.orderStatusIconColor};
  border-radius: 50%;
  width: 35px;
  height: 35px;
`;
const RenderOrderCompleteIcon = ({ orderType, status, displayComplete }) => {
  if (orderType === 'pickup')
    return (
      <>
        {status === ORDER_READY_TO_PICKUP ? (
          <>
            {appConfig.styleConfig?.orderStatusSummaryStep3InactiveIconPickup &&
            displayComplete ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3InactiveIconPickup
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : appConfig.styleConfig
                ?.orderStatusSummaryStep3ActiveIconPickup &&
              !displayComplete ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3ActiveIconPickup
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <FontAwesomeIconWrapper>
                <Icon
                  className={'fas fa-store'}
                  style={{
                    fontSize: '18px',
                    color: '#ffffff',
                  }}
                />
              </FontAwesomeIconWrapper>
            )}
          </>
        ) : (
          <>
            {appConfig.styleConfig
              ?.orderStatusSummaryStep3InactiveIconPickup ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3InactiveIconPickup
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <FontAwesomeIconWrapper disabled>
                <Icon
                  className={'fas fa-store'}
                  style={{
                    fontSize: '18px',
                    color: '#ffffff',
                  }}
                />
              </FontAwesomeIconWrapper>
            )}
          </>
        )}
      </>
    );

  if (orderType === 'delivery')
    return (
      <>
        {status === ORDER_ON_DELIVERY ? (
          <>
            {appConfig.styleConfig
              ?.orderStatusSummaryStep3InactiveIconDelivery &&
            displayComplete ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3InactiveIconDelivery
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : appConfig.styleConfig
                ?.orderStatusSummaryStep3ActiveIconDelivery &&
              !displayComplete ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3ActiveIconDelivery
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <FontAwesomeIconWrapper disabled>
                <Icon
                  className={'fas fa-car-side'}
                  style={{
                    fontSize: '18px',
                    color: '#ffffff',
                  }}
                />
              </FontAwesomeIconWrapper>
            )}
          </>
        ) : (
          <>
            {appConfig.styleConfig
              ?.orderStatusSummaryStep3InactiveIconDelivery ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3InactiveIconDelivery
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <FontAwesomeIconWrapper disabled>
                <Icon
                  className={'fas fa-car-side'}
                  style={{
                    fontSize: '18px',
                    color: '#ffffff',
                  }}
                />
              </FontAwesomeIconWrapper>
            )}
          </>
        )}
      </>
    );

  if (orderType === 'drop_off')
    return (
      <>
        {status === ORDER_COMPLETE ? (
          <>
            {appConfig.styleConfig?.orderStatusSummaryStep3ActiveIconDropOff ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3ActiveIconDropOff
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <FontAwesomeIconWrapper>
                <Icon
                  className={'fas fa-shopping-bag'}
                  style={{
                    fontSize: '18px',
                    color: '#ffffff',
                  }}
                />
              </FontAwesomeIconWrapper>
            )}
          </>
        ) : (
          <>
            {appConfig.styleConfig
              ?.orderStatusSummaryStep3InactiveIconDropOff ? (
              <div>
                <img
                  src={
                    appConfig.styleConfig
                      ?.orderStatusSummaryStep3InactiveIconDropOff
                  }
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <FontAwesomeIconWrapper disabled>
                <Icon
                  className='fas fa-shopping-bag'
                  style={{
                    fontSize: '18px',
                    color: '#ffffff',
                  }}
                />
              </FontAwesomeIconWrapper>
            )}
          </>
        )}
      </>
    );
};

const UberDeliveryDetails = ({ orderStatusModalData }) => {
  if (
    orderStatusModalData?.delivery_provider !== 'uberdaas' ||
    !appConfig?.isUberManagedService
  ) {
    return null; // or handle accordingly if not Uber delivery
  }

  return (
    <UberDetail>
      We've partnered with Uber for this delivery. In case of any
      delivery-related issues, please call:{' '}
      <a href='tel:+18669873744'>+1 (866) 987-3744</a>
      <br />
      <br />
      <span>Store ID: {orderStatusModalData?.external_store_id} </span>
    </UberDetail>
  );
};

const StepsSummary = ({
  orderStatusModalData,
  orderReadyTime,
  phoneNumber,
  displayComplete,
  locations,
}) => {
  const staticOrderSummaryClients = [
    'madradish',
    'madradish_catering',
    'tahinis',
    'basilbox_catering',
    'onekingwest_amenities',
  ];
  const staticOrderSummary = useMemo(() => {
    const selectedBusiness = locations?.find(
      (business) => business.id === orderStatusModalData?.business_id
    );
    return (
      <>
        <DetailTitle id='OrderStatusModal-OrderSummary'>
          Order Summary
        </DetailTitle>
        {orderStatusModalData?.order_type === 'delivery' ? (
          <>
            <Subtitle>{appConfig?.deliveringTo ?? 'Delivering to:'}</Subtitle>
            <AddressWrapper>
              {orderStatusModalData?.customer_address?.city && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.customer_address?.line1},
                </Text>
              )}
              {orderStatusModalData?.customer_address?.city && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.customer_address?.city},
                </Text>
              )}
              {orderStatusModalData?.customer_address?.state && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.customer_address?.state},
                </Text>
              )}
              {orderStatusModalData?.customer_address?.zip && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.customer_address?.zip}
                </Text>
              )}
            </AddressWrapper>
            <DetailsWrapper>
              <span>Estimated Time:</span>
              <span>
                {`${moment(orderStatusModalData?.order_date).format('MMM DD')} -
                ${orderReadyTime}`}
              </span>
            </DetailsWrapper>
            <DetailsWrapper display='block' margin='15px 0  0 0'>
              <div>Order fulfilled by:</div>
              <div>{orderStatusModalData?.business_name}</div>
              <AddressWrapper>
                {orderStatusModalData?.business_address?.city && (
                  <Text marginRight='5px'>
                    {orderStatusModalData?.business_address?.line1},
                  </Text>
                )}
                {orderStatusModalData?.business_address?.city && (
                  <Text marginRight='5px'>
                    {orderStatusModalData?.business_address?.city},
                  </Text>
                )}
                {orderStatusModalData?.business_address?.state && (
                  <Text marginRight='5px'>
                    {orderStatusModalData?.business_address?.state},
                  </Text>
                )}
                {orderStatusModalData?.business_address?.zip && (
                  <Text marginRight='5px'>
                    {orderStatusModalData?.business_address?.zip}
                  </Text>
                )}
              </AddressWrapper>
              {selectedBusiness?.phone && (
                <DetailsWrapper margin='10px 0'>
                  <Icon
                    className='fa fa-phone'
                    style={{
                      fontSize: '15px',
                      color: '#000',
                    }}
                  />
                  {selectedBusiness?.phone}
                </DetailsWrapper>
              )}
            </DetailsWrapper>
            <DetailsWrapper display='block' margin='15px 0  0 0'>
              <div>Order Placed:</div>
              <div>
                {`${moment(orderStatusModalData?.order_created_at).format(
                  'MMM DD'
                )} -
                ${moment(orderStatusModalData?.order_created_at).format(
                  'hh:mm A'
                )}`}
              </div>
            </DetailsWrapper>
          </>
        ) : orderStatusModalData?.order_type === 'pickup' ? (
          <>
            <Subtitle>
              {appConfig?.pickingUpFrom ?? 'Picking up from:'}
            </Subtitle>
            <AddressWrapper>
              {orderStatusModalData?.business_address.city && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.line1},
                </Text>
              )}
              {orderStatusModalData?.business_address.city && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.city},
                </Text>
              )}
              {orderStatusModalData?.business_address.state && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.state},
                </Text>
              )}
              {orderStatusModalData?.business_address.zip && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.zip}
                </Text>
              )}
            </AddressWrapper>
            {selectedBusiness?.phone && (
              <DetailsWrapper margin='10px 0'>
                <Icon
                  className='fa fa-phone'
                  style={{
                    fontSize: '15px',
                    color: '#000',
                  }}
                />
                {selectedBusiness?.phone}
              </DetailsWrapper>
            )}
            <DetailsWrapper>
              <span>Estimated Time:</span>
              <span>
                {`${moment(orderStatusModalData?.order_date).format('MMM DD')} -
                ${orderReadyTime}`}
              </span>
            </DetailsWrapper>
            <DetailsWrapper display='block' margin='15px 0  0 0'>
              <div>Order Placed:</div>
              <div>
                {`${moment(orderStatusModalData?.order_created_at).format(
                  'MMM DD'
                )} -
                ${moment(orderStatusModalData?.order_created_at).format(
                  'hh:mm A'
                )}`}
              </div>
            </DetailsWrapper>
          </>
        ) : (
          <>
            <Subtitle>{appConfig?.droppingOffTo ?? 'Drop off to:'}</Subtitle>

            <AddressWrapper>
              {orderStatusModalData?.business_address.city && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.line1},
                </Text>
              )}
              {orderStatusModalData?.business_address.city && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.city},
                </Text>
              )}
              {orderStatusModalData?.business_address.state && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.state},
                </Text>
              )}
              {orderStatusModalData?.business_address.zip && (
                <Text marginRight='5px'>
                  {orderStatusModalData?.business_address?.zip}
                </Text>
              )}
            </AddressWrapper>
            {selectedBusiness?.phone && (
              <DetailsWrapper margin='10px 0'>
                <Icon
                  className='fa fa-phone'
                  style={{
                    fontSize: '15px',
                    color: '#000',
                  }}
                />
                {selectedBusiness?.phone}
              </DetailsWrapper>
            )}
            <DetailsWrapper>
              <span>Estimated Time:</span>
              <span>
                {`${moment(orderStatusModalData?.order_date).format('MMM DD')} -
            ${orderReadyTime}`}
              </span>
            </DetailsWrapper>
            <DetailsWrapper display='block' margin='15px 0  0 0'>
              <div>Order Placed:</div>
              <div>
                {`${moment(orderStatusModalData?.order_created_at).format(
                  'MMM DD'
                )} -
            ${moment(orderStatusModalData?.order_created_at).format(
              'hh:mm A'
            )}`}
              </div>
            </DetailsWrapper>
          </>
        )}
        <Feedback orderId={orderStatusModalData?.orderId} />
      </>
    );
  }, [orderStatusModalData, locations, orderReadyTime]);
  return (
    <Wrapper>
      <OrderNumber>Order #{orderStatusModalData?.orderId}</OrderNumber>
      {staticOrderSummaryClients.includes(appConfig.appSource) ? (
        staticOrderSummary
      ) : (
        <>
          <SummaryWrapper>
            <Step1Icon>
              {orderStatusModalData?.status === 2 && displayComplete ? (
                <>
                  {appConfig.styleConfig
                    ?.orderStatusSummaryStep1InactiveIcon ? (
                    <div>
                      <img
                        src={
                          appConfig.styleConfig
                            ?.orderStatusSummaryStep1InactiveIcon
                        }
                        alt='wait for confirmation'
                      />
                    </div>
                  ) : (
                    <FontAwesomeIconWrapper disabled={true}>
                      <Icon
                        className='fas fa-check'
                        style={{
                          fontSize: '18px',
                          color: '#ffffff',
                        }}
                      />
                    </FontAwesomeIconWrapper>
                  )}
                </>
              ) : orderStatusModalData?.status === ORDER_SUBMITTED ? (
                <>
                  {appConfig.styleConfig?.orderStatusSummaryStep1ActiveIcon ? (
                    <div>
                      <img
                        src={
                          appConfig.styleConfig
                            ?.orderStatusSummaryStep1ActiveIcon
                        }
                        alt='wait for confirmation'
                      />
                    </div>
                  ) : (
                    <FontAwesomeIconWrapper>
                      <Icon
                        className='fas fa-check'
                        style={{
                          fontSize: '18px',
                          color: '#ffffff',
                        }}
                      />
                    </FontAwesomeIconWrapper>
                  )}
                </>
              ) : (
                <>
                  {appConfig.styleConfig
                    ?.orderStatusSummaryStep1InactiveIcon ? (
                    <div>
                      <img
                        src={
                          appConfig.styleConfig
                            ?.orderStatusSummaryStep1InactiveIcon
                        }
                        alt='wait for confirmation'
                      />
                    </div>
                  ) : (
                    <FontAwesomeIconWrapper disabled={true}>
                      <Icon
                        className='fas fa-check'
                        style={{
                          fontSize: '18px',
                          color: '#ffffff',
                        }}
                      />
                    </FontAwesomeIconWrapper>
                  )}
                </>
              )}
            </Step1Icon>
            <Step2Icon>
              {orderStatusModalData?.status === 2 && displayComplete ? (
                <>
                  {appConfig.styleConfig
                    ?.orderStatusSummaryStep2InactiveIcon ? (
                    <div>
                      <img
                        src={
                          appConfig.styleConfig
                            ?.orderStatusSummaryStep2InactiveIcon
                        }
                        alt='wait for confirmation'
                      />
                    </div>
                  ) : (
                    <FontAwesomeIconWrapper disabled={true}>
                      <Icon
                        className='fas fa-hat-chef'
                        style={{
                          fontSize: '18px',
                          color: '#ffffff',
                        }}
                      />
                    </FontAwesomeIconWrapper>
                  )}
                </>
              ) : orderStatusModalData?.status === ORDER_ACCEPTED ? (
                <>
                  {appConfig.styleConfig?.orderStatusSummaryStep2ActiveIcon ? (
                    <div>
                      <img
                        src={
                          appConfig.styleConfig
                            ?.orderStatusSummaryStep2ActiveIcon
                        }
                        alt='wait for confirmation'
                      />
                    </div>
                  ) : (
                    <FontAwesomeIconWrapper>
                      <Icon
                        className='fas fa-hat-chef'
                        style={{
                          fontSize: '18px',
                          color: '#ffffff',
                        }}
                      />
                    </FontAwesomeIconWrapper>
                  )}
                </>
              ) : (
                <>
                  {appConfig.styleConfig
                    ?.orderStatusSummaryStep2InactiveIcon ? (
                    <div>
                      <img
                        src={
                          appConfig.styleConfig
                            ?.orderStatusSummaryStep2InactiveIcon
                        }
                        alt='wait for confirmation'
                      />
                    </div>
                  ) : (
                    <FontAwesomeIconWrapper disabled={true}>
                      <Icon
                        className='fas fa-hat-chef'
                        style={{
                          fontSize: '18px',
                          color: '#ffffff',
                        }}
                      />
                    </FontAwesomeIconWrapper>
                  )}
                </>
              )}
            </Step2Icon>
            <Step3Icon>
              <RenderOrderCompleteIcon
                orderType={orderStatusModalData?.order_type}
                status={orderStatusModalData?.status}
                displayComplete={displayComplete}
              />
            </Step3Icon>
            <Divider1>
              <VerticalRect
                customColor={
                  appConfig.styleConfig?.orderStatusSummaryVerticalLineColor ||
                  appConfig.styleConfig?.orderStatusIconColor
                }
              />
            </Divider1>
            <Divider2>
              <VerticalRect
                customColor={
                  appConfig.styleConfig?.orderStatusSummaryVerticalLineColor ||
                  appConfig.styleConfig?.orderStatusIconColor
                }
              />
            </Divider2>
            <Title1>
              <OrderDetailTitle>Order placed</OrderDetailTitle>
            </Title1>
            <Title2>
              <OrderDetailTitle>Being Prepared</OrderDetailTitle>
            </Title2>
            <Title3>
              <OrderDetailTitle>
                {orderStatusModalData?.order_type === 'delivery'
                  ? orderStatusModalData?.status === 5
                    ? 'Order Delivered'
                    : 'Out for delivery'
                  : orderStatusModalData?.order_type === 'pickup'
                  ? 'Ready for Pickup'
                  : appConfig.styleConfig?.stepsSummeryDropOffReady ??
                    'Ready for drop-off'}
              </OrderDetailTitle>
            </Title3>
            <SubTitle1>
              <OrderDetailDescription>
                {orderStatusModalData?.business_name} -{' '}
                {orderStatusModalData?.business_address.line1},{' '}
                {orderStatusModalData?.business_address.state}{' '}
                {orderStatusModalData?.business_address.zip}
                <div>{new AsYouType('US').input(phoneNumber)}</div>
              </OrderDetailDescription>
            </SubTitle1>
            <SubTitle2></SubTitle2>
            <SubTitle3>
              {orderStatusModalData?.order_type === 'delivery' && (
                <OrderDetailDescription>
                  {orderStatusModalData?.customer_address.line1 +
                    ', ' +
                    orderStatusModalData?.customer_address.city +
                    ', ' +
                    orderStatusModalData?.customer_address.state}
                </OrderDetailDescription>
              )}
              {orderStatusModalData?.order_type === 'drop_off' && (
                <OrderDetailDescription>
                  {orderStatusModalData?.business_address.line1 +
                    ', ' +
                    orderStatusModalData?.business_address.city +
                    ', ' +
                    orderStatusModalData?.business_address.state +
                    ', ' +
                    orderStatusModalData?.drop_off_location.option.label +
                    ', ' +
                    orderStatusModalData?.drop_off_location.option.value}
                </OrderDetailDescription>
              )}
            </SubTitle3>
            <Time1>
              <OrderDetailTitle>
                {moment(orderStatusModalData?.order_created_at).format(
                  'hh:mm A'
                )}
              </OrderDetailTitle>
            </Time1>
            <Time2></Time2>
            <Time3>
              <OrderDetailTitle>Approx. {orderReadyTime}</OrderDetailTitle>
            </Time3>
            <Date1>
              <OrderDetailDescription>
                {moment(orderStatusModalData?.order_created_at).format(
                  'MMMM Do'
                )}
              </OrderDetailDescription>
            </Date1>
            <Date2></Date2>
            <Date3>
              <OrderDetailDescription>
                {moment(orderStatusModalData?.order_date).format('MMMM Do')}
              </OrderDetailDescription>
            </Date3>
          </SummaryWrapper>
          <UberDeliveryDetails orderStatusModalData={orderStatusModalData} />
        </>
      )}
    </Wrapper>
  );
};

export default StepsSummary;
